import { InterpretationComponent } from './../../interpretation/pages/interpretation/interpretation.component';
import { ComponentHistoryImages, Condition, SystemInspectionImagesM } from '../../interpretation/models/interpretation.model';
import { MeasurementToolsViewModel } from '../../measurement-points-admin/model/measurement-points.model';
import { CustomeEvaluationRangeVM } from '../../CustomEval/custom-eval.model';
import { AnswerList } from '../../GET_NEW_UI/perform-induction/perform-induction';
import { AnswersOptionsVM } from '../../Training/setup-training-types.model';
import { ModelBaseObservations } from '../../setup-models/setup-models.model';
import { BogieShim, BogieShimRequestModel } from '../../../shared/components/bogie-shim/bogie-shim-model';
import { EqualiserBar } from '../../../entities/setup/model';

export class CreateNewInspectionViewModel {
  /**
   *
   */
  constructor(equipmentId: number) {
    this.InspectionDate = new Date();
    this.EquipmentId = equipmentId;
    this.TravelProperties = new InspectionTravelPropertyViewModel(equipmentId);
    this.ObservationReadings = new InspectionObservationsReadingsViewModel(equipmentId);
    this.ObservationComments = new InspectionObservationsCommentsViewModel(equipmentId);
    this.UnderfootConditions = new InspectionUnderfootConditionsViewModel(equipmentId);
    this.ObservationImages = new InspectionObservationsImagesViewModel(equipmentId);
  }
  public EquipmentId: number;
  public InspectionId: number;
  public SMUReading: number;
  public SMUImages: string;
  public WorkOrder: string;
  public PMUReading: number;

  public InspectionDate: Date;
  public InspectionNotes: string;
  public JobsiteNotes: string;
  public TravelProperties: InspectionTravelPropertyViewModel;
  public UnderfootConditions: InspectionUnderfootConditionsViewModel;
  public ObservationReadings: InspectionObservationsReadingsViewModel;
  public ObservationComments: InspectionObservationsCommentsViewModel;
  public ObservationImages: InspectionObservationsImagesViewModel;
  public StringDate: string;
  public AdditionalObservationDrafts: InspectionAdditionalObservationListsViewModel[];
  public UOD :string;
  observationInfo:ModelBaseObservations[];
  hasCRoller: boolean;
  showCRoller: boolean;
  JobsiteId: number;
  Jobsite: string;
  InspectionEqImagePath: string;
  LTD: number;
  BogieShimLeft: BogieShim;
  BogieShimRight: BogieShim;
  SystemDataChainLeft: SystemInspectionDetailView;
  SystemDataFrameLeft: SystemInspectionDetailView
  SystemDataChainRight: SystemInspectionDetailView;
  SystemDataFrameRight: SystemInspectionDetailView;
  SMUValidation: boolean = true;
  EqualiserBarData: EqualiserBar;
  LocationId: number;
}

export class InspectionUnderfootConditionsViewModel {
  public InspectionId: number;
  public Impact: number;
  public Abrasive: number;
  public Moisture: number;
  public Packing: number;
  public equipmentId: number;
  constructor(equipmentId: number) {
    this.Impact = 0;
    this.Abrasive = 0;
    this.Moisture = 0;
    this.Packing = 0;
    this.equipmentId = equipmentId;
  }
}

export class InspectionTravelPropertyViewModel {
  public InspectionId: number;
  public ForwardTravelHr: number;
  public ForwardTravelKm: number;
  public ReverseTravelHr: number;
  public ReverseTravelKm: number;
  public equipmentId: number;
  constructor(equipmentId: number) {
    this.equipmentId = equipmentId;
  }
}

export class InspectionObservationsReadingsViewModel {
  public InspectionId: number;
  public TrackSagL: number;
  public TrackSagR: number;
  public CannonExtL: number;
  public CannonExtR: number;
  public ScallopL: number;
  public ScallopR: number;
  public NoDryJointsL: number;
  public NoDryJointsR: number;
  public LinkNoL:number;
  public LinkNoR:number;

  public equipmentId: number;
  constructor(equipmentId: number) {
    this.equipmentId = equipmentId;
  }
}

export class InspectionObservationsCommentsViewModel {
  public InspectionId: string;
  public equipmentId: number;
  public TrackSagLComment: string;
  public TrackSagRComment: string;
  public CannonExtLComment: string;
  public CannonExtRComment: string;
  public ScallopLComment: string;
  public ScallopRComment: string;
  public NoDryJointsLComment: string;
  public NoDryJointsRComment: string;

  public LinkNoLComment: string;
  public LinkNoRComment: string;

  constructor(equipmentId: number) {
    this.equipmentId = equipmentId;
  }
}

export class InspectionObservationsImagesViewModel {
  public InspectionId: number;
  public TrackSagLImage: string;
  public TrackSagRImage: string;
  public CannonExtLImage: string;
  public CannonExtRImage: string;
  public ScallopLImage: string;
  public ScallopRImage: string;
  public NoDryJointsLImage: string;
  public NoDryJointsRImage: string;
  public SMUImages:string;
  public LinkNoLImage: string;
  public LinkNoRImage: string;
  public equipmentId: number;
  constructor(equipmentId: number) {
    this.equipmentId = equipmentId;
  }
}


export class SystemInspectionDetailViewVM {
  Data: SystemInspectionDetailView;
  Status: number;
  Message: string;
}

export class SystemInspectionDetailView {
  public InspectionDraftId: number;
  public EquipmentId: number;
  public SystemId: number;

  public SystemName: string;
  public SystemSerialNumber: string;
  public SystemImage: string;
public CastFrame:number;
public ToeOutFrame:number;
public Type:number;
SystemImages:SystemInspectionImagesM[];
SystemComment:string;
public Components: ComponentOnSystemInspectionViewModel[];

  constructor() {

  }
}
export class ComponentOnSystemInspectionViewModel {
  public InspectionDraftDetailId: number;
  public GeneralEqUnitId: number;
  public Name: string;

  public ComponentImage: string;
  public Position: string;

  public WornPercentage: number;
  public MeasurementReading: number;

  public ToolId: number;
  public ToolName: string;
  public CMU: number;
  public CPMU:number;

  public Images: InspectionDraftImagesView[];

  public TempOneImageOnly: InspectionDraftImagesView;

  public Comment: string;

  public Eval: number;
  public IsChild: boolean;
  public IsMeasuredInInches: boolean;

  public PossibleTools: MeasurementToolsViewModel[];

  public EquipmentId: number;

  public CompartTypeId: number;
  public CompartId: number;

  public ActualPosition: number;


  public OriginalPosition: number;
public isExcludeC:boolean=false;
public EvalCode:string;
public hasUTTool:boolean;
public UTequvelent:number;
public DOC:number = 0;

public ParentComponentId: number;
public Side : number;
public isImageUrl: boolean;
public ComponentPitch: number;
}


export class ImageViewModel {
  public ImageId: number;
  public ImageComment: string;
  public ImageData: string;
}



export class WornPercentageCalculateViewModel {
  public GeneralEqunitId: number;
  public Reading: number;
  public ToolId: number;
  public Impact: number;
  public EquipmentId: number;
  public IsMeasuredInInches: boolean;
  public EvaluationRange:CustomeEvaluationRangeVM
  public CompartTypeId:number;
}


export class InspectionDraftImagesView {
  public Id: number;
  public Image: string;
  public Comment: string;
  public Title: string;
  public ImagePath:string;
}


export enum ObservationListLevel {
  Customer = 0,
  Model = 1,
  Family = 2,
}



export class AdditionalObservationListViewModel {
  public Id: number;

  public CustomerId: number;
  public ModelId: number;
  public FamilyId: number;

  public Title: string;
  public Disabled: boolean;

  public QuestionTypeId:number;
  public QuestionTypeName:string;

  public Worn0percent:number;
  public Worn100percent:number;
  public NoOfDecimal:number;
  public ObsImages:InspectionAdditionalObservationImagesVM[]

  constructor() {
   this.Disabled = false;
    }



}


export class AdditonalObsNumaricalLimits {

  public Id: number;
  public Worn0percent:number;
  public Worn100percent:number;
  public NoOfDecimal:number; 
}



export class InspectionAdditionalObservationListsViewModel {
  public Id: number;
  public ReferenceId: number;
  public InspectionDraftId: number;
  public Comment: string;
  public Title: string;
  public Image: string;
  public ObsImages:InspectionAdditionalObservationImagesVM[]
  public AnswerList:AnswersOptionsVM[];
  public QuestionTypeId:number;
  public HasAnswerd:boolean;
  public InspectionAdditionalObId:number;
  public wornPercent:number;
}
export class InspectionAdditionalObservationImagesVM{
  public Id:number;
  public AdditionalInspectionId:number;
  public Image :string;
  public ImagePath:string;
}

export enum PopupEndPoint {
  ObservationListCreateInspection = 1,
  ObservationListInterpretation = 2,
  InventoryComponent = 3,
  AddNewInspectionComponent=4,
  SystemInspectionImages=5,
  SystemComment=6,
  CreateEditInspectionComponent=8,
  InterpretationComponent = 9
}


export enum SwapRollerEndPoint {
  CreateNewInspection = 1,
  Interpretation = 2,
  RecordNewAction = 3,
}

export class ModelSelectionOptionViewModel {
  public Id: number;
  public Name: string;
}

export class InspectionTypeConfigurationViewModel {
  public InspectionTypeId: number;
  public InspectionTypeName: string;
  public SelectType:boolean;
  public CompartsViewModels: CompartsOnModelViewModel[];
}
export class CompartsOnModelViewModel {
  public ModelId: number;
  public CompartId: number;
  public CompartTypeName: string;
  public MeasurementPoints: InspectionTypeMeasurementPointViewModel[];
}
export class InspectionTypeMeasurementPointViewModel {
  public Id: number;
  public MeasurementPointRecordId: number;
  public ShouldSkipDuringInspection: boolean;
  public Order: number;
  public MeasurementPointName: string;
}

export class InspectionValidatorRequest {
    equipmentId: number;
    inspectionDate: string;
    newSMU: number;
    inspectionId:number;
}

export class InspectionValidationViewVM {
    Status!: number;
    Message!: string;
}

interface IDictionary {
  add(key: string, value: any): void;
  remove(key: string): void;
  containsKey(key: string): boolean;
  keys(): string[];
  values(): any[];
}

export class Dictionary {
  _keys: string[] = [];
  _values: any[] = [];

  constructor(init: { key: string; value: any }[]) {
    for (let x = 0; x < init.length; x++) {
      this[init[x].key] = init[x].value;
      this._keys.push(init[x].key);
      this._values.push(init[x].value);
    }
  }

  add(key: string, value: any) {
    this[key] = value;
    this._keys.push(key);
    this._values.push(value);
  }

  remove(key: string) {
    const index = this._keys.indexOf(key, 0);
    this._keys.splice(index, 1);
    this._values.splice(index, 1);

    delete this[key];
  }

  keys(): string[] {
    return this._keys;
  }

  values(): any[] {
    return this._values;
  }

  containsKey(key: string) {
    if (typeof this[key] === 'undefined') {
      return false;
    }

    return true;
  }

  toLookup(): IDictionary {
    return this;
  }
}

export class Observations {
  public test() {
    const pair: { [key: string]: { comment: string; photo: string } } = {};
  }
}
